import type { FunctionComponent } from "react";
import { PredefinedTasksGrid } from "~/components/predefined-tasks/predefined-tasks-grid";
import { useAssertBlankConversation } from "~/hooks/use-init-rag";
import { Screen } from "~/screens/screen";

// A "start a new chat" surface: ensure a blank session so a picked prompt sends into it, then
// routes to /conversation/:id (same as a typed first message).
export const PredefinedTasksScreen: FunctionComponent = () => {
  useAssertBlankConversation();

  return (
    <Screen>
      <div className="p-6">
        <PredefinedTasksGrid />
      </div>
    </Screen>
  );
};
